import React from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { useGetNotificationsQuery } from "@monorepo/services/api/notifications";
import theme from "@monorepo/styles/theme";
import { Box } from "@mui/material";
import { reverse } from "named-urls";

interface IProps {
  hideTitle?: boolean;
  children: React.ReactNode;
}

export const NotificationsMenuLink: React.FC<IProps> = ({ hideTitle, children }) => {
  const { t } = useTranslation();
  const { data: notifications } = useGetNotificationsQuery();
  const showUnreadNotifications = !!notifications?.find(({ seen }) => !seen);
  const firstNotificationId = notifications && notifications.length > 0 ? notifications[0].id : "";

  return (
    <NavLink
      style={{
        color: theme.palette.nobelGray.main,
        textDecoration: "none",
        fontSize: theme.typography.body1.fontSize,
        placeSelf: "center",
        cursor: "pointer",
      }}
      activeStyle={{
        color: `${theme.palette.primary.main}!important`,
      }}
      to={
        firstNotificationId
          ? reverse(routeConfig.dashboard.notifications.notification.notificationId, {
              notificationId: firstNotificationId,
            })
          : routeConfig.dashboard.notifications.self
      }
    >
      <Box
        component="span"
        sx={{
          display: "flex",
          position: "relative",
          justifyContent: "center",
          margin: "0 auto",
          width: theme.spacing(3),
        }}
      >
        {children}
        {showUnreadNotifications && (
          <Box
            component="span"
            sx={{
              position: "absolute",
              top: "8px",
              right: "3px",
              width: "8px",
              height: "8px",
              backgroundColor: theme.palette.error.dark,
              borderRadius: "50%",
            }}
          />
        )}
      </Box>
      {!hideTitle && (
        <Box
          component="span"
          sx={{
            display: "none",
            [theme.breakpoints.down("md")]: {
              display: "block",
            },
          }}
        >
          {t("navigation.notifications")}
        </Box>
      )}
    </NavLink>
  );
};
